import { generateId, getCurrentNumberId } from '#models/general/ids';
import { getSubStepValues } from '#models/general/steps';
import Input from '#components/general/Input';

import { WASH_IDS_FIELDS, WASH_SUBSTEPS_IDS } from './constants';

const generateMainWashId = (washNumber, week) => `W${washNumber} - ${week}`;

const generateWashId = generateId(generateMainWashId, 'washRunDateAndTime');

export const getWashIdsFields = ({ values, errors }) => {
  const getWashIdsValues = getSubStepValues(WASH_SUBSTEPS_IDS.WASH_IDS, values, errors);
  return [
    {
      ...getWashIdsValues(WASH_IDS_FIELDS.WASH_ID, false),
      Component: Input,
      disabled: true,
      value: generateWashId(values, getCurrentNumberId(values?.mashingId))
    }
  ];
};
